import {
  faArrowDownToLine,
  faEllipsis,
} from "@fortawesome/pro-solid-svg-icons";

import type { GenerationTileAction } from "@/components/Tiles/GenerationTile/types";
import {
  Icon,
  IconButtonGroup,
  TileButton,
  TileButtonsContainer,
} from "@/components/ui-v2";

interface VideoGenerationTileButtonsProps {
  onAction: (event: React.MouseEvent, action: GenerationTileAction) => void;
}

export const VideoGenerationTileButtons = (
  props: VideoGenerationTileButtonsProps,
) => {
  const { onAction } = props;

  const handleAction =
    (action: GenerationTileAction) => (e: React.MouseEvent) => {
      e.stopPropagation();
      onAction(e, action);
    };

  return (
    <TileButtonsContainer>
      <IconButtonGroup>
        <TileButton
          aria-label="Download"
          data-testid="btn-download"
          onClick={handleAction("DOWNLOAD")}
        >
          <Icon icon={faArrowDownToLine} fontSize="small" />
        </TileButton>
      </IconButtonGroup>
      <TileButton
        aria-label="View more options"
        data-testid="btn-more-options"
        onClick={handleAction("SHOW_MORE_OPTIONS")}
      >
        <Icon icon={faEllipsis} fontSize="small" />
      </TileButton>
    </TileButtonsContainer>
  );
};
